import OnboardingLayoutFooter from './OnboardingLayoutFooter';

export default OnboardingLayoutFooter;
